import React from "react";
import "./Whatsapp.css";

const Whatsapp = () => {
  return (
    <>
      <a className="whatsapp-link" href="https://wa.me/message/UGNOJ2HSFVUSE1">
        <i className="fab fa-whatsapp"></i>
      </a>
    </>
  );
};

export default Whatsapp;
